import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  Dropdown,
  DropdownItem,
  getColor,
  Icons,
  Tooltip,
  Typography,
} from "fds";
import "./index.scss";
import utilsCommon from "../../shared/utils/common";
import {
  getAdminInfoFromLocalStorage,
  getUserInfoFromLocalStorage,
} from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import ProfileModal from "./ProfileModal";
import useLoginStore from "../../redux/dispatcher/useLoginStore";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { Member } from "../../types/workgroup";
import { t } from "i18next";

interface LoginProps {
  isAdmin?: boolean;
}

const HeaderUserDropdown: React.FC<LoginProps> = ({ isAdmin = false }) => {
  const { sessionLogout } = useLoginStore();
  const { workgroupState } = useWorkgroupStore();
  const user = isAdmin
    ? (getAdminInfoFromLocalStorage() as string | "")
    : (getUserInfoFromLocalStorage() as string | "");
  const loginDto: LoginDto = JSON.parse(user);
  const [openProfileModalType, changeOpenProfileModalType] = useState<
    "ACCOUNT" | "ALARM" | "CLOSE"
  >("CLOSE");
  const [userInfo, changeUserInfo] = useState<Member>();

  useEffect(() => {
    if (workgroupState.memberProfile) {
      changeUserInfo(workgroupState.memberProfile[0].userInfo);
    }
  }, [workgroupState.memberProfile]);
  const handleLogout = async () => {
    sessionLogout().then(
      () => (window.location.href = `${process.env.PUBLIC_URL}/login`)
    );
  };
  return (
    <>
      {openProfileModalType !== "CLOSE" && (
        <ProfileModal
          open={true}
          onClose={() => changeOpenProfileModalType("CLOSE")}
          startTab={openProfileModalType}
        />
      )}
      <Dropdown
        buttonWidth={300}
        labelNode={
          <Avatar
            name={loginDto?.userInfo?.userName}
            uniqueCode={utilsCommon.getUserColor(
              loginDto?.ecoUserInfo?.userType
            )}
          />
        }
        align={"right"}
      >
        <Box classes="ecoheader-profile--userInfo">
          <Avatar
            name={loginDto?.userInfo.userName}
            uniqueCode={utilsCommon.getUserColor(
              loginDto?.ecoUserInfo?.userType
            )}
            size={"48"}
          />
          <Box direction="column" classes="mg ml-12">
            <Tooltip message={loginDto?.userInfo.userName} maxWidth={200}>
              <Typography type="subtitle1" ellipsis>
                {loginDto?.userInfo.userName}
              </Typography>
            </Tooltip>
            <Tooltip
              message={utilsCommon.getUserPositionNDept({
                deptName: userInfo
                  ? userInfo.deptName
                  : loginDto?.userInfo.deptName,
                positionName: loginDto?.userInfo.positionName,
                userType: loginDto?.ecoUserInfo?.userType,
              })}
              maxWidth={200}
            >
              <Typography
                type="body4_rg"
                ellipsis
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {utilsCommon.getUserPositionNDept({
                  deptName: userInfo
                    ? userInfo.deptName
                    : loginDto?.userInfo.deptName,
                  positionName: loginDto?.userInfo.positionName,
                  userType: loginDto?.ecoUserInfo?.userType,
                })}
              </Typography>
            </Tooltip>
          </Box>
        </Box>
        {window.eco.serviceType === "OCI" &&
          // (workspaceDetail?.createUserId === myId ||
          decodeURI(window.location.pathname.split("/")[1]) ===
            // )
            "My Space" && <DropdownItem label="구매 관리" />}
        {!isAdmin && (
          <DropdownItem
            label={t("common.setting")}
            onClick={() => changeOpenProfileModalType("ACCOUNT")}
          />
        )}
        {!isAdmin && (
          <DropdownItem
            label={t("header.setAlarm.button")}
            onClick={() => changeOpenProfileModalType("ALARM")}
          />
        )}
        {window.eco.serviceType !== "OCI" &&
          loginDto?.ecoUserInfo?.admin &&
          !isAdmin && (
            <DropdownItem
              label={t("header.manageWeb")}
              onClick={() => {
                window.location.href = `${process.env.PUBLIC_URL}/admin/login`;
              }}
              trailingIcon={
                <Icons
                  variant="line"
                  label="arrowUpRight"
                  classes="mg ml-auto"
                />
              }
            />
          )}
        {isAdmin && (
          <DropdownItem
            label={t("header.adminGuide")}
            onClick={() => {
              window.open(
                window.eco.serviceType === "CLOUD"
                  ? t("header.adminGuideLink")
                  : t("header.adminGuideLinkOnpremise"),
                "_blank"
              );
            }}
          />
        )}
        <DropdownItem state="divider" />
        <DropdownItem
          label={t("header.logout")}
          type="warning"
          onClick={handleLogout}
        />
      </Dropdown>
    </>
  );
};

export default HeaderUserDropdown;
